import React from 'react';
import { Box, Container, useMediaQuery, useTheme } from '@mui/material';

const ProjectPartners = () => {
    const primaryBlue = '#1F1B9E';
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box sx={{
            bgcolor: 'white',
            py: { xs: 2, sm: 3 },
        }}>
            <Container maxWidth="lg">
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: { xs: 2, sm: 3, md: 4 },
                    flexWrap: 'wrap',
                    flexDirection: { xs: 'column', md: 'row' }
                }}>
                    {/* FH Logo */}
                    <Box component="a" href="https://www.campus02.at/" target="_blank" rel="noopener noreferrer">
                        <Box
                            component="img"
                            src="/old/fh_logo.png"
                            alt="Fachhochschule Logo"
                            sx={{
                                height: { xs: '60px', sm: '70px', md: '80px' },
                                objectFit: 'contain',
                                maxWidth: '100%'
                            }}
                        />
                    </Box>


                    {/* Vertical/Horizontal Divider based on screen size */}
                    <Box sx={{
                        height: { xs: '4px', md: '70px' },
                        width: { xs: '70px', md: '4px' },
                        bgcolor: primaryBlue,
                        mx: { xs: 0, md: 2 },
                        my: { xs: 1, md: 0 },
                        display: { xs: isTablet ? 'block' : 'none', md: 'block' }
                    }} />

                    {/* RWTH Logos */}
                    <Box component="a" href="https://www.time.rwth-aachen.de/" target="_blank" rel="noopener noreferrer">
                        <Box
                            component="img"
                            src="/old/2_logos_am_ende.png"
                            alt="RWTH Logos"
                            sx={{
                                height: { xs: '60px', sm: '70px', md: '80px' },
                                objectFit: 'contain',
                                maxWidth: '100%'
                            }}
                        />
                    </Box>

                    {/* Vertical/Horizontal Divider based on screen size */}
                    <Box sx={{
                        height: { xs: '4px', md: '70px' },
                        width: { xs: '70px', md: '4px' },
                        bgcolor: primaryBlue,
                        mx: { xs: 0, md: 2 },
                        my: { xs: 1, md: 0 },
                        display: { xs: isTablet ? 'block' : 'none', md: 'block' }
                    }} />

                    {/* Innolab Logo */}
                    <Box component="a" href="https://www.innolab.at/" target="_blank" rel="noopener noreferrer">
                        <Box
                            component="img"
                            src="/old/innolab_logo.png"
                            alt="Innolab Logo"
                            sx={{
                                height: { xs: '55px', sm: '65px', md: '70px' },
                                objectFit: 'contain',
                                maxWidth: '100%'
                            }}
                        />
                    </Box>

                </Box>
            </Container>
        </Box>
    );
};

export default ProjectPartners;